import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import styled from "styled-components";
import { WelcomeStyled } from "../welcomeView/welcomeView";
import microphone from "./microphone.svg";

//const textExample = "Mentalia cursos";
//const textRamdon = ["Certificación", "Cursos", "Cursos en línea", "Desarrollo personal", "Academia", "Certificado", "México con innovación en educación", "Aprende en línea", "SEDEMA"];
const textRamdon = [
    {
        pharas: 'No cuentes los días, haz que los días cuenten',
        author: 'Muhammad Ali'
    },
    {
        pharas: 'El amor no tiene cura, pero es la cura para todos los males',
        author: 'Leonard Cohen'
    },
    {
        pharas: 'El mejor momento del día es ahora',
        author: 'Pierre Bonnard'
    },
    {
        pharas: 'Sé el cambio que quieres ver en el mundo',
        author: 'Mahatma Gandhi'
    },
    {
        pharas: 'Piensa, sueña, cree y atrévete',
        author: 'Walt Disney'
    },
    {
        pharas: 'Cree que puedes y casi lo habrás logrado',
        author: 'Theodore Roosevelt'
    },
    {
        pharas: 'Vayas donde vayas, ve con todo tu corazón',
        author: 'Confucio'
    },
    {
        pharas: 'La mejor forma de predecir el futuro es creándolo',
        author: 'Abraham Lincoln​'
    },
    {
        pharas: 'Solo imagina lo precioso que puede ser arriesgarse y que todo salga bien',
        author: 'Mario Benedetti​'
    },
    {
        pharas: 'El que tiene un porqué para vivir, puede soportar casi cualquier cómo',
        author: 'Viktor Frankl'
    },
    {
        pharas: 'Si quieres cambiar el mundo, cámbiate a ti mismo',
        author: 'Mahatma Ghandi​'
    },
    {
        pharas: 'La vida no se trata de encontrarte a ti mismo, sino de crearte a ti mismo',
        author: 'Bernard Shaw'
    },
    {
        pharas: 'Alguien se sienta en una sombra hoy porque alguien plantó un árbol hace mucho tiempo',
        author: 'Warren Buffet'
    },
]
const CheckSettings = ({ setMicrophoneOK }) => {
    const [listening, setListening] = useState(false);
    const [text, setText] = useState('');
    const [quality, setQuality] = useState(0);
    const [correct, setCorrect] = useState(false);
    const [textExample, setTextExample] = useState(textRamdon[0]);

    const refLottie = useRef(null);

    const runSpeechRecognition = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognition.lang = "es";

        recognition.onstart = function () {
            setListening(true);
        };

        recognition.onspeechend = function () {
            setListening(false);
            recognition.stop();
        }

        recognition.onresult = function (event) {
            let transcript = event.results[0][0].transcript;
            transcript.replace(/,/g, '')
            transcript = removeAccents(transcript); 
            transcript = transcript.toLowerCase();

            let newTextExample = textExample?.pharas.replace(/,/g, '');
            newTextExample = removeAccents(newTextExample);
            newTextExample = newTextExample.toLowerCase()

            //if (transcript.toLowerCase() === textExample.toLowerCase() && confidence > 0.9)
            if (transcript == newTextExample)
                setCorrect(true);
            else setCorrect(false)

            setText(event.results[0][0].transcript);
        };

        recognition.start();
    }

    const changePharas = () => {
        const ramdonKey = Math.floor(Math.random() * textRamdon.length);
        setTextExample(textRamdon[ramdonKey]);
    }

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } 

    useEffect(() => {
        if (correct) {
            setMicrophoneOK(true);
        }
    }, [correct]);

    useEffect(() => {
        const ramdonKey = Math.floor(Math.random() * textRamdon.length);
        setTextExample(textRamdon[ramdonKey]);
    }, []);

    return (
        <>
            <Background />
            <Content>
                <div style={{ textAlign: 'center' }}>
                    <h3 className="test-title">
                        <span className="evaluation-name"> Prueba de audio </span><br />
                        Pulsa el botón y lee la frase dentro del recuadro
                    </h3>
                    <div style={{ textAlign: 'center' }}>
                        <label style={{ fontSize: 11, cursor: 'pointer' }} onClick={changePharas}>Click para intentar con otra frase</label>
                    </div>
                    <DivPhara>
                        <h4 style={{ fontWeight: 800 }}>"{textExample?.pharas}"</h4>

                    </DivPhara>
                    <div style={{ textAlign: 'right', width: '75%', margin: '0 auto' }}>
                        <label style={{ fontSize: 12 }}>{textExample?.author}</label>
                    </div>


                    <div
                        style={{
                            width: '30%',
                            margin: '0 auto'
                        }}
                    >
                        {!listening ?
                            <div
                                className="select-button"
                                variant="contained"
                                color="secondary"
                                size="large"
                                onClick={runSpeechRecognition}
                            >
                                <Player
                                    ref={refLottie}
                                    autoplay={false}
                                    loop
                                    src="https://assets9.lottiefiles.com/packages/lf20_znayulli.json"
                                    style={{ height: '100px', width: '100px' }}
                                >
                                    <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
                                </Player>
                            </div>
                            :
                            <Player
                                ref={refLottie}
                                autoplay={true}
                                loop
                                src="https://assets9.lottiefiles.com/packages/lf20_znayulli.json"
                                style={{ height: '100px', width: '100px' }}
                            >
                                <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
                            </Player>
                        }
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <p style={{ fontSize: 22 }}><strong>Tu:</strong>  {text ? text : "________________"}</p>
                    </div>
                </div>
            </Content>
        </>
    )
};

const Background = styled.section`
    background: rgb(0 0 0 / 25%);
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    
`;

const Content = styled.section`
    background: white;
    position: fixed;
    width: 50%;
    top: 10%;
    left: 25%;
    border-radius: 15px;
    min-height: 330px;
    & > h1 {
        font-size: 25px;
    }
    & > div >h4 {
        font-weight: 100;
    }
    & > div > h5 {
        font-weight: 100;
    }
`;

const DivPhara = styled.section`
    background: #fff;
    box-shadow: 10px 10px 16px -1px rgba(158,158,158,0.75);
    padding: 20px;
    width: 75%;
    margin: 0 auto;
    border-radius: 10px;
`;

export default CheckSettings;